import { Row, Col, Button, Popconfirm } from 'antd';
import Item from 'antd/lib/list/Item';
import Utility from 'Core/Utility';
import React, { CSSProperties, SyntheticEvent } from 'react';
import styled from 'styled-components';
import { BolFileModel } from '../BolFilesEditor';
import IFilterSelectOption from 'components/Forms/DataGrid/FilterSelectbox/IFilterSelectOption';
interface Props {
  item: BolFileModel;
  onRemoveItem?: (item: BolFileModel) => void;
  style: CSSProperties;
  fileUrl: string;
  readonly?: boolean;
  fileTypes?: IFilterSelectOption[];
}

let Container = styled(Row)`
 padding: 5px 10px;
 border: 1px solid #d9d9d9;
 box-shadow: 0 2px 0 rgb(0 0 0 / 2%);
 border-radius: 4px;
`;

export default (props: Props) => {

  let onRemoveClicked = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    props.onRemoveItem?.call(undefined, props.item);
  }

  const fileUrl = props.fileUrl + props.item.fileId;
  let fileType = props.fileTypes?.find(x => x.value == props.item.bolFileTypeId);

  return (
    <Container type="flex" justify="space-between" style={{ ...props.style }}>
      <Col span={fileType ? 6 : 0} >
        <i>{fileType ? fileType?.text : null}</i>
      </Col>
      <Col span={fileType ? 10 : 19} >
        <a href={fileUrl}>
          {props.item.name}
        </a>
      </Col>
      {!props.readonly && <Col offset={1} span={fileType ? 3 : 4}>
        <Popconfirm onConfirm={onRemoveClicked} trigger="click" title="Are you sure?" okText="Yes" cancelText="No">
          <Button icon="delete" />
        </Popconfirm>
      </Col>}
    </Container>
  );
}